import React, { useMemo } from 'react';
import { Grid, Paper, Stack, Typography } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import PaidIcon from '@mui/icons-material/Paid';
import { useTranslation } from 'src/text';
import { ExpenseCategory, useExpenses } from '../expense-context';
import { card } from '../styles';

export const SummaryCards: React.FC = () => {
  const { expenseLabels } = useTranslation();
  const { expenses, total } = useExpenses();

  const byCategory = useMemo(() => {
    const grouped: Record<string, number> = {};
    expenses.forEach(exp => {
      grouped[exp.category] = (grouped[exp.category] || 0) + exp.amount;
    });
    return Object.entries(grouped).map(([label, amount]) => ({
      label,
      amount,
    }));
  }, [expenses]);

  return (
    <Grid container spacing={2} mb={2}>
      <Grid item xs={12} md={4}>
        <Paper variant="outlined" sx={card}>
          <Stack direction="row" spacing={1} alignItems="center">
            <PaidIcon color="primary" />
            <Typography variant="subtitle1">
              {expenseLabels.totalSpend}
            </Typography>
          </Stack>
          <Typography variant="h5" fontWeight={700} mt={1}>
            ${total.toFixed(2)}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {expenseLabels.totalSpendDescription}
          </Typography>
        </Paper>
      </Grid>
      <Grid item xs={12} md={8}>
        <Paper variant="outlined" sx={card}>
          <Stack direction="row" spacing={1} alignItems="center" mb={1}>
            <TrendingUpIcon color="success" />
            <Typography variant="subtitle1">
              {expenseLabels.byCategory}
            </Typography>
          </Stack>
          {byCategory.length === 0 ? (
            <Typography variant="body2" color="text.secondary">
              {expenseLabels.byCategoryPlaceholder}
            </Typography>
          ) : (
            <Stack spacing={0.5}>
              {byCategory.map(item => (
                <Stack
                  key={item.label}
                  direction="row"
                  justifyContent="space-between">
                  <Typography variant="body2">
                    {expenseLabels.categories[item.label as ExpenseCategory] ??
                      item.label}
                  </Typography>
                  <Typography variant="body2" fontWeight={600}>
                    ${item.amount.toFixed(2)}
                  </Typography>
                </Stack>
              ))}
            </Stack>
          )}
        </Paper>
      </Grid>
    </Grid>
  );
};
